import type { SubLabelProps } from './types';

export function SubLabel({ children }: SubLabelProps) {
  return (
    <span className="mb-1 block text-xs uppercase tracking-wide text-gray-400">
      {children}
    </span>
  );
}

export type { SubLabelProps };
